<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>教职绩效->模板管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.title" placeholder="考核标题"></el-input>
                </div>
            </div>
            &nbsp;
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>

            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary" @click="setAdd()">生成模板</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                element-loading-background = "rgba(255, 255,255,0.7)"
                :element-loading-text = "loadingText"
                v-loading="loading" 
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="title" label="考核标题"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="startYear" label="开始年份"  width="80px"></el-table-column>
                <el-table-column prop="endYear" label="结束年份"  width="80px"></el-table-column>
                <el-table-column prop="schoolName" label="学校名称"  width="120px"></el-table-column>
                <el-table-column label="发布状态"  width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.releaseSign == 1">
                            待发布
                        </div>
                        <div v-else-if="scope.row.releaseSign == 2">
                            已发布
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="companyName" label="制定者"  width="120px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button 
                            @click.native.prevent="lookInfo(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">查看模板</span>
                        </el-button>
                        <el-button
                            @click.native.prevent="setCheckUser(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">
                               {{scope.row.releaseSign == 2?'查看审核人':'配置审核人'}}
                            </span>
                        </el-button>
                        <el-button v-if="scope.row.releaseSign == 1"
                            style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                        <el-button  v-if="scope.row.releaseSign == 1"
                            @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">发布</span>
                        </el-button>
                        <el-button  v-if="scope.row.releaseSign == 2"
                            @click.native.prevent="lookTeacher(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">查看被考核人</span>
                        </el-button>
                        <el-button  v-if="scope.row.releaseSign == 2"
                            @click.native.prevent="cancel(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">撤销</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <!--关口学区模板-->
        <div v-if="gkxqTemplateVisible">
            <gkxqTemplate ref="gkxqTemplate"></gkxqTemplate>
        </div>
        <!--配置审核人-->
        <div v-if="setCheckUserVisible">
            <setCheckUser ref="setCheckUser"></setCheckUser>
        </div>
        <!--发布-->
        <div v-if="updateTemplateVisible">
            <updateTemplate ref="updateTemplate"></updateTemplate>
        </div>
        <!--查看被考核人-->
        <div v-if="lookTeacherAssessVisible">
            <lookTeacherAssess ref="lookTeacherAssess"></lookTeacherAssess>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddTemplate.vue';
    import gkxqTemplate from './GKXQMain.vue';
    import setCheckUser from './SetCheckUser.vue';
    import updateTemplate from './UpdateTemplate.vue';
    import lookTeacherAssess from './LookTeacherAssess.vue';

    export default {
        name:"TeacherTemplate",
        data(){
            return{
                loading:false,
                loadingText:"",

                addVisible:false,
                gkxqTemplateVisible:false,
                setCheckUserVisible:false,
                updateTemplateVisible:false,
                lookTeacherAssessVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    title:""
                },
                data:[],
                depts:[],
                pre:"", // 模板前缀：Gkxq-关口学区
            }
        },
        components: {
            add,gkxqTemplate,setCheckUser,updateTemplate,lookTeacherAssess
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.teacherTemplateListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId
                };

                // 获取学校机构编码，然后跳转不同的模板,Gkxq-关口学区
                for(let i=0;i<this.depts.length;i++){
                    let dept=this.depts[i];
                    if(dept.id == this.form.deptId){
                        this.pre=dept.number;
                        break;
                    }
                }

                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //查看模板
            lookInfo(data){
                // if(this.pre == 'GKXQ'){ // 关口学区
                    this.gkxqTemplateVisible=true;
                    this.$nextTick(() => {
                        this.$refs['gkxqTemplate'].init(data);
                    })
                // }
            },
            //修改界面
            setCheckUser(row){
                
                // 验证当前模板，学区人员是否配置完成未初始化，就不能配置审核人
                let url  = this.teacherAssessAreaUserCheckAreaUserSetUrl;
                let data = {
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.setCheckUserVisible=true;
                        this.$nextTick(() => {
                            this.$refs['setCheckUser'].init(row);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });

                
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.teacherTemplateRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 发布
            setUpdate(data){
                let url  = this.teacherTemplateSetcheckListUrl;
                let param = {
                    deptId:this.form.deptId,
                    teacherTemplateManageId:data.id
                };
                this.apiPost(url,param).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                        if(res.data.length == 0){
                            this.$commonFn.showTip('审核人未配置，请先配置然后再进行发布',3);
                            return;
                        }
                        this.updateTemplateVisible=true;
                        this.$nextTick(() => {
                            this.$refs['updateTemplate'].init(data);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            lookTeacher(data){
                this.lookTeacherAssessVisible=true;
                this.$nextTick(() => {
                    this.$refs['lookTeacherAssess'].init(data.id);
                })  
            },
            cancel(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm2('撤销会将已发布的教师绩效考核全部撤回，是否继续？',this.cancelSuccess);
            },
            cancelSuccess(){
                this.loading=true;
                this.loadingText="撤销中...";

                let url = this.cancelTeacherAssessUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/TeacherTemplate.vue